import { API } from '../../utils';
import { IParams } from '../types';
import { GW_SERVICES_PREFIXES } from '../../constants';

const { C300 } = GW_SERVICES_PREFIXES;

export interface INewAreaMeterReadings {
  id: string;
  values: number[];
}

export const GetAreaMeters = (params: IParams) => {
  return API.get(`/${C300}/models/area_meters/`, undefined, params);
};

export const GetAreaMetersAllReadings = (params: IParams) => {
  return API.get(`/${C300}/forms/area_meters/all_readings/`, undefined, params);
};

export const PatchAreaMeterReadings = (
  areaId: string,
  data: INewAreaMeterReadings[]
) =>
  API.gatewayPatch(`/${C300}/forms/area_meters/all_readings/`, areaId, {
    meters: data,
  });

/* Список просрачиваемых счётчиков по квартире (для отчёта по просроченным счётчикам) */
export const GetAreaOverdueMeters = (areaId: string, params: IParams) =>
  API.get(`/${C300}/area_meters/overdue/`, areaId, params);

/* Домовые приборы учёта */
export const GetHouseMeters = (params: IParams) =>
  API.get(`/${C300}/models/house_meter/`, undefined, params);

/* Получение домовых тепловых счетчиков */
export const GetHeatHouseMeters = (params: IParams) =>
  API.get(`/${C300}/boilers/get_heat_meters/`, undefined, params);

/* Получение домового прибора учёта по его ID */
export const GetHouseMetersById = (meterId: string) =>
  API.get(`/${C300}/boilers/heat_house_meter/`, meterId);

/* Создание домового прибора учёта */
export const CreateHouseMeters = (params: IParams) =>
  API.gatewayPost(`/${C300}/boilers/heat_house_meter/`, params);

/* Замена домового прибора учёта */
export const ReplaceMeter = (id: string, params: IParams) =>
  API.gatewayPatch(`/${C300}/boilers/close_meter/`, id, params);

/* Редактирование домового прибора учёта */
export const PatchHouseMeters = (id: string, params: IParams) =>
  API.gatewayPatch(`/${C300}/boilers/heat_house_meter/`, id, params);

/* Удаление домового прибора учёта */
export const DeleteHouseMeter = (id: string) =>
  API.delete(`/${C300}/boilers/heat_house_meter/`, id);

/* Добавление файлов к счетчику */
export const SendMeterFiles = (id: string, data: FormData) =>
  API.patchFilesGtwy(`/${C300}/boilers/heat_house_meter/files/`, id, data);

export const DeleteMeterFile = (fileId: string) =>
  API.delete(`/${C300}/boilers/heat_house_meter/files/`, fileId);

// Отправка SMS с настройками
export const SendSettings = (params: IParams) =>
  API.get(`/${C300}/forms/automation/adapter_tuning/`, undefined, params);
